import React from 'react';
import FilterableDatatable from "../../components/table/filterable-data-table";
import * as api from "../../api";
import ContractsVolumeTableHeader from "./contracts-volume-table-header";
import ContractsVolumeTableRow from "./contracts-volume-table-row";
import ArrayDataProvider from "../../components/table/data-providers/array-data-provider";
import {from} from "linq";
import {Grid} from "semantic-ui-react";
import MonthlyUnitLineChart from "../../components/charts/custom/monthly-unit-line-chart";
import {ChartColors} from "../../components/charts/constants/chart-color-constants";

export default class ContractVolumes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chartData: [],
            dataProvider: new ArrayDataProvider([]),
            volumeUnits: [{ field: "baseTotalCapacity", label: "Total Volume", color: ChartColors.a }],
            capacityUnits: [{ field: "baseTradedCapacity", label: "Traded Capacity", color: ChartColors.a }]
        };

        this.state.dataProvider.onDataSourceChanged.subscribe(() => {
            this.setState({chartData: this.state.dataProvider.getData()});
        });

        this.fetchData();
    }

    fetchData()
    {
        api.getContractVolumeList(this.props.customerId, this.props.contractId)
            .then(({data}) => this.transformData(data))
            .then(this.state.dataProvider.updateDataSource)
    }

    transformData(data) {
        const transformedDataset = [];

        const enumerableData = from(data);
        const periods = enumerableData
            .orderBy(x => x.periodStartDate)
            .select(x => x.periodName)
            .distinct()
            .toArray();

        periods.forEach(period => {
            const periodData = enumerableData
                .where(x => x.periodName === period);

            const baseloadData = periodData.singleOrDefault(x => x.loadTypeId === 0);
            const peakData = periodData.singleOrDefault(x => x.loadTypeId !== 0);

            const transformedData = {
                month: baseloadData ? baseloadData.periodName : peakData.periodName,
                date: baseloadData ? baseloadData.periodStartDate : peakData.periodStartDate,
                baseTotalCapacity: baseloadData ? baseloadData.totalVolume : null,
                baseTradedCapacity: baseloadData ? baseloadData.tradedCapacity : null,
                baseExposedCapacity: baseloadData ? baseloadData.exposedCapacity : null,
                baseTraded: baseloadData ? baseloadData.percentTraded : null,
                baseExposed: baseloadData ? baseloadData.percentExposed : null,
                peakTotalCapacity: peakData ? peakData.totalVolume : null,
                peakTradedCapacity: peakData ? peakData.tradedCapacity : null,
                peakExposedCapacity: peakData ? peakData.exposedCapacity : null,
                peakTraded: peakData ? peakData.percentTraded : null,
                peakExposed: peakData ? peakData.percentExposed : null
            };

            transformedDataset.push(transformedData);
        });

        return transformedDataset;
    }

    render() {
        return (
            <React.Fragment>
                <Grid stackable columns='equal'>
                    <Grid.Row>
                        <Grid.Column>
                            {this.state.chartData.length > 0 && <MonthlyUnitLineChart units={this.state.volumeUnits} data={this.state.chartData} title={"Total Volumes"} /> }
                        </Grid.Column>
                        <Grid.Column>
                            {this.state.chartData.length > 0 && <MonthlyUnitLineChart units={this.state.capacityUnits} data={this.state.chartData} title={"Traded Capacity"} /> }
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <FilterableDatatable dataProvider={this.state.dataProvider} name="contract-volumes" canExport={true}
                                                 refreshDataTrigger={this.state.dataProvider.onDataSourceChanged}
                                                 headerComponent={ContractsVolumeTableHeader} rowComponent={ContractsVolumeTableRow} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

            </React.Fragment>
        );
    }
}